import React, { FunctionComponent } from "react";
import styled from "styled-components";

interface WrapperInfoProps {
  className?: string;
}

const Wrapper: FunctionComponent<WrapperInfoProps> = ({
  className,
  children,
}) => {
  return <div className={className || ""}>{children}</div>;
};

export const WrapperInfo = styled(Wrapper)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`;
